<template>
  <div class="vx-card mt-5">
    <div class="vx-card__body card-body">
      <deduction-popup
        :show="ModifyPopup"
        @finish="onfinish"
        @close="closeModifyPopup"
      >
      </deduction-popup>
      <div class="flex justify-between">
        <div>
          <vs-button @click="createAccount()" class="bg_l_green">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("CreateNewDeductionAndIncrease") }}
          </vs-button>
        </div>
        <div v-if="deductionAndIncrease.length">
          <vs-button
            v-if="editable"
            type="filled"
            svgClasses="h-4 w-4"
            class="ico"
            @click.prevent="saveEdit"
            >{{ $t("SaveEditDeductionAndIncrease") }}</vs-button
          >
          <vs-button v-else @click.prevent="editAccount()" class="bg_l_green">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("EditNewDeductionAndIncrease") }}
          </vs-button>
        </div>
      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full mb-base">
          <table
            v-if="deductionAndIncrease.length"
            class="basic-tbl"
            id="colored-table"
          >
            <thead class="z-0 relative border-0">
              <tr>
                <th style="width: 5%" class="border-0">#</th>
                <th style="width: 10%" class="border-0">{{ $t("DeductionAndIncreaseType") }}</th>
                <th style="width: 10%" class="border-0">{{ $t("ToleranceType") }}</th>
                <th style="width: 10%" class="border-0">{{ $t("Amounts") }}</th>
                <th style="width: 10%" class="border-0">{{ $t("Description") }}</th>
                <th style="width: 10%" class="border-0">{{ $t("Action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in deductionAndIncrease">
                <td class="border-0">{{ index + 1 }}</td>
                <td class="border-0" style="width: 10%">
                  <div v-if="editable">
                    <v-select
                      class="m-0"
                      label="name"
                      name="Type"
                      :options="deductionAndIncreaseTypes"
                      v-model="row.deductionAndIncreaseType"
                      :reduce="(x) => x.id"
                      dir="rtl"
                    >
                    </v-select>
                  </div>
                  <div v-else>
                    {{
                      row.deductionAndIncreaseType &&
                      row.deductionAndIncreaseType === 1
                        ? "کسر"
                        : "اضافه"
                    }}
                  </div>
                </td>
                <td class="border-0" style="width: 10%">
                  <div v-if="editable">
                    <v-select
                      class="m-0"
                      label="name"
                      name="Telorance"
                      :options="toleranceTypes"
                      v-model="row.toleranceType"
                      :reduce="(x) => x.id"
                      dir="rtl"
                    >
                    </v-select>
                  </div>
                  <div v-else>
                    {{
                      row.toleranceType && row.toleranceType === 1
                        ? "درصدی"
                        : "مقداری"
                    }}
                  </div>
                </td>

                <td class="border-0" style="width: 10%">
                  <div v-if="editable">
                    <vs-input v-model="row.amount" name="Amount" />
                  </div>
                  <div v-else>
                    {{ row.amount ? row.amount : "-" }}
                  </div>
                </td>
                <td class="border-0" style="width: 30%">
                  <div v-if="editable">
                    <vs-textarea
                      rows="2"
                      class="mt-4"
                      name="Description"
                      v-model="row.description"
                    />
                  </div>
                  <div v-else>
                    {{ row.description ? row.description : "-" }}
                  </div>
                </td>
                <td class="border-0" style="width: 10%">
                  <div v-if="editable">
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deleteAccount(index)"
                      class="ml-4 d-inline"
                    ></vs-button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="flex justify-end w-full ml-5">
        <vs-button
          type="filled"
          class="mb-4 mt-4"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DeductionPopup from "./DeductionPopup.vue";
import vSelect from "vue-select";

export default {
  components: {
    DeductionPopup,
    "v-select": vSelect,
  },
  data() {
    return {
      ModifyPopup: false,
      editable: false,
      model: {},
      deductionAndIncrease: [],
      pOId: -1,
      modalModel: {},
      deductionAndIncreaseTypes: [
        { name: "کسر", id: 1 },
        { name: "اضافه", id: 2 },
      ],
      toleranceTypes: [
        { name: "درصدی", id: 1 },
        { name: "مقداری", id: 2 },
      ],
    };
  },

  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchShipmentById: "procurementShipping/fetchShipmentById",
      saveDeductionAndIncrease: "procurementShipping/saveDeductionAndIncrease",
    }),
    load() {
      var id = this.$route.params.id;
      this.pOId = this.$route.params.id;
      this.fetchShipmentById(id).then((r) => {
        this.model = r;
        this.deductionAndIncrease =
          this.model.shipmentDeductionAndIncreases;
      });
    },
    deleteAccount(index){
      this.deductionAndIncrease.splice(index,1)
    },
    createAccount(id) {
      this.ModifyPopup = true;
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish(model) {
      this.deductionAndIncrease.push(model);
      this.closeModifyPopup();
    },
    editAccount() {
      this.editable = !this.editable;
    },
    saveEdit() {
      this.editable = !this.editable;
    },
    submitForm() {
      var payload = {
        shipmentId: this.pOId,
        shipmentDeductionAndIncreases: this.deductionAndIncrease,
      };
      this.saveDeductionAndIncrease(payload).then(() => {
        setTimeout(() => {
          this.$router.go(-1);
        }, 3000);
      });
    },
  },
};
</script>
<style>
.basic-tbl {
  border: 0 !important;
  & tbody {
    & tr {
      & td {
        border-bottom: 0.2px solid #696161 !important;
      }
    }
  }
}
</style>